module.exports = __webpack_public_path__ + "static/media/big_smartsampa_logo_mobile_dark.cac8bf01.png";